import PropTypes from 'prop-types';
import styles from './Overlay.module.scss';

const Overlay = ({ children }) => {
  return (
    <div
      className={`d-flex justify-content-center align-items-center h-100 w-100 position-fixed top-0 start-0 ${styles['overlay']}`}
    >
      {children}
    </div>
  );
};

Overlay.propTypes = {
  children: PropTypes.node
};

export default Overlay;
